import { render, staticRenderFns } from "./MSTalkMessagePhotoAlbum.vue?vue&type=template&id=3a6fd480&"
import script from "./MSTalkMessagePhotoAlbum.vue?vue&type=script&lang=js&"
export * from "./MSTalkMessagePhotoAlbum.vue?vue&type=script&lang=js&"
import style0 from "./MSTalkMessagePhotoAlbum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {VIcon})
